import { getLeadFactorySeller } from './getLeadFactorySeller';
import { cropPhone } from './cropPhone';
export var getSinglePhoneData = function getSinglePhoneData(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers;
  var leadFactory = getLeadFactorySeller(sellers);
  var builder = builders[0];
  var seller = sellers[0];
  if (leadFactory) {
    var _leadFactory$dynamicC;
    return {
      realtyUserId: leadFactory.realtyUserId,
      isOpen: leadFactory.isOpen,
      phone: leadFactory.dynamicPhone || cropPhone({
        phone: leadFactory.phone,
        isFullPhone: true
      }),
      name: leadFactory.name || '',
      logoUrl: leadFactory.avatarUrl || '',
      workTime: leadFactory.workTime || null,
      siteBlockId: ((_leadFactory$dynamicC = leadFactory.dynamicCalltracking) === null || _leadFactory$dynamicC === void 0 ? void 0 : _leadFactory$dynamicC.siteBlockId) || null,
      type: leadFactory.type || 'Агентство',
      buttonText: leadFactory.buttonText || 'Показать контакты',
      title: 'Контакты застройщика',
      isBuilder: false
    };
  }
  if (builder) {
    var _builder$dynamicCallt;
    return {
      realtyUserId: builder.realtyUserId,
      isOpen: builder.isOpen,
      phone: builder.dynamicPhone || cropPhone({
        phone: builder.phone,
        isFullPhone: true
      }),
      name: builder.name || '',
      logoUrl: builder.logoUrl || '',
      workTime: builder.workTime || null,
      siteBlockId: ((_builder$dynamicCallt = builder.dynamicCalltracking) === null || _builder$dynamicCallt === void 0 ? void 0 : _builder$dynamicCallt.siteBlockId) || null,
      type: 'Застройщик',
      buttonText: 'Контакты застройщика',
      title: 'Контакты застройщика',
      isBuilder: true
    };
  }
  return {
    realtyUserId: seller.realtyUserId,
    isOpen: seller.isOpen,
    phone: seller.dynamicPhone || cropPhone({
      phone: seller.phone,
      isFullPhone: true
    }),
    name: seller.name || '',
    logoUrl: seller.avatarUrl || '',
    workTime: seller.workTime || null,
    siteBlockId: null,
    type: 'Агентство недвижимости',
    buttonText: 'Показать контакты',
    title: 'Контакты застройщика',
    isBuilder: false
  };
};